import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'

type SkeletonImageProps = {
    height: string | number
    width?: string | number
}

const SkeletonImage = ({ height, width = '100%' }: SkeletonImageProps): ReactElement => {
    return <Grid height={height} width={width} backgroundColor="moon-3" noExpand />
}

export default memo(SkeletonImage)
